module.exports = __webpack_public_path__ + "img/Q.fead7d81.jpg";